import { Box, Grid, Typography } from "@mui/material";
import Footer from "components/common/dialog/Footer";
import Header from "components/common/dialog/Header";
// import { useNavigate } from "react-router-dom";
import { assetsObj } from "services/images";

const SuccessPage = () => {
  // const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          height: "100%",
          color: "white",
          backgroundImage: `url(${assetsObj.Circles}),url(${assetsObj.gradientImg}) `,
          backgroundSize: "contain, cover",
          backgroundPosition: "left, center",
          backgroundRepeat: "no-repeat, no-repeat",
          overflow: "auto",
          position: "relative",
          "@media (max-width: 900px)": {
            backgroundImage: `url(${assetsObj.gradientImg}) `,
            backgroundSize: "cover",
            backgroundPosition: "center",
          },
        }}
      >
        <Header />
        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            height: "calc(100vh - 133px)",
            maxWidth: "auto",
            "@media (max-width: 900px)": {
              marginTop: "1rem",
            },
          }}
        >
          <Grid container>
            <Grid
              item
              xs={12}
              md={6}
              className="leftContent"
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 7,
              }}
            >
              <Box
                sx={{
                  maxHeight: { lg: "45vh", md: "50vh", xs: "20vh" },
                  position: "relative",
                  marginTop: 4,
                  "@media (max-width: 900px)": {
                    marginTop: 0.3,
                  },
                }}
                component="img"
                src={assetsObj.whiteAffirmate}
              />
              <Box
                sx={{
                  maxHeight: { lg: "100vh", md: "100vh", xs: "100vh" },

                  position: "absolute",
                  marginLeft: 5,
                  "@media (min-width: 899px)": {
                    display: "none",
                  },
                }}
                component="img"
                src={assetsObj.whitecircle}
              />
            </Grid>

            <Grid
              container
              item
              xs={12}
              md={6}
              sx={{
                marginBottom: 10,
              }}
            >
              <Grid container item xs={12} sx={{ margin: "auto" }}>
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      textAlign: "center",
                      color: "white",
                      fontWeight: 300,
                      marginBottom: 2,
                    }}
                  >
                    Welcome to Affirmate!
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography
                    variant="body2"
                    sx={{
                      textAlign: "center",
                      color: "white",
                      fontWeight: 300,
                      fontSize: "16px",
                      marginBottom: 4,
                    }}
                  >
                    Download the App
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      margin: "auto",
                      display: "flex",
                      gap: 1,
                      justifyContent: "center",
                      maxWidth: "40%",
                      "@media (max-width: 499px)": {
                        display: "flex",
                        flexDirection: "column",
                      },
                    }}
                  >
                    <Grid item xs={12}>
                      <a
                        style={{
                          width: "100%",
                        }}
                        href="https://apps.apple.com/us/app/affirmate-90-sec-meditation/id6449148631"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={assetsObj.appStoreLogo} alt="App Store" />
                      </a>
                    </Grid>
                    <Grid item xs={12}>
                      <a
                        style={{
                          width: "100%",
                        }}
                        href="https://play.google.com/store/apps/details?id=com.affirmate.app"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={assetsObj.playStoreLogo} alt="Play Store" />
                      </a>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>

        <Footer />
      </Box>
    </>
  );
};

export default SuccessPage;
